import { FiltersTranslationKeys, DocumentationTranslationKeys } from 'intl/keys';
import { availableFieldLabelKey } from 'intl';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import { ExtendedFieldTranslationKeys } from 'intl/keys';
import { createUserEntityFilterInput } from './createUserEntityFilterInput';

export const UserFilterInput = createUserEntityFilterInput({
  labelId: FiltersTranslationKeys.filterTypeAssignee,
  id: 'user-filter',
});

export const AssigneeUserFilterInput = createUserEntityFilterInput({
  labelId: availableFieldLabelKey(IssueFieldNames.assignee),
  id: 'assignee-user-filter',
});

export const ExecutorUserFilterInput = createUserEntityFilterInput({
  labelId: availableFieldLabelKey(IssueFieldNames.executor),
  id: 'executor-user-filter',
});

export const CreatedByUserFilterInput = createUserEntityFilterInput({
  labelId: DocumentationTranslationKeys.columnLabelCreatedBy,
  id: 'created-by-user-filter',
});

export const IssueCreatedByUserFilterInput = createUserEntityFilterInput({
  labelId: availableFieldLabelKey(IssueFieldNames.createdBy),
  id: 'issue-created-by-user-filter',
});

export const ModifiedByUserFilterInput = createUserEntityFilterInput({
  labelId: DocumentationTranslationKeys.columnLabelModifiedBy,
  id: 'modified-by-user-filter',
});

export const SupervisorUserFilterInput = createUserEntityFilterInput({
  labelId: ExtendedFieldTranslationKeys.supervisor,
  id: 'supervisor-user-filter',
});
